import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Ruler, Smartphone } from 'lucide-react';

// The Blueprint/Prototype fork (Ali, 2026-08-12): after an idea, the user explicitly chooses
// prompts (Blueprint = the build pack, handed to any builder) or a working downloadable app
// (Prototype). Not exclusive — a project can have both; each is its own generation and charge.
// Rendered on top of both stages; entitlement visibility is the caller's job (ProjectPage
// already filters stages by manifest entitlements).
export default function ForkSwitch({ projectId, stage, showBuild = true, showPrototype = true }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!showBuild || !showPrototype) return null; // no fork to show when one door is off

  const doors = [
    { key: 'build', icon: Ruler, label: t('fork.blueprint'), sub: t('fork.blueprintSub'), testId: 'fork-blueprint' },
    { key: 'prototype', icon: Smartphone, label: t('fork.prototype'), sub: t('fork.prototypeSub'), testId: 'fork-prototype' },
  ];
  return (
    <div className="grid grid-cols-2 gap-2 mb-3" data-testid="fork-switch">
      {doors.map(({ key, icon: Icon, label, sub, testId }) => {
        const active = stage === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={testId}
            onClick={() => { if (!active) navigate(`/project/${projectId}/${key}`); }}
            className={`text-start rounded-xl border p-4 transition-colors ${
              active
                ? 'border-primary bg-primary/5'
                : 'border-border bg-card hover:border-primary/50'
            }`}
            aria-pressed={active}
          >
            <span className="flex items-center gap-2 font-semibold text-foreground">
              <Icon className={`h-4 w-4 ${active ? 'text-primary' : 'text-muted-foreground'}`} /> {label}
            </span>
            <span className="block text-xs text-muted-foreground mt-1">{sub}</span>
          </button>
        );
      })}
    </div>
  );
}
